export const GlobalConstants = {
  LOYALTY_PATH: '/loyalty-system/api/v1/loyalty',
  MAIL_PATH: '/rbfa-mailing-service/api/v1/sendgrid',
  INVITATION_CARDS: {
    BASE_DOCS: 'invitation_cards',
    SETTINGS_DOCS: 'settings',
    CARDS_DOCS: 'cards'
  },
  FEATURE_FLAGS_PREFIX: 'enable',
}